import React from "react";
import PropTypes from "prop-types";

const MenuRightIcon = ({
  alt = "Menu Right",
  className = "",
  size = 24,
  onClick = () => {},
}) => (
  <svg
    aria-label={alt}
    className={`wink-icon ${className}`}
    width={size}
    height={size}
    onClick={onClick}
    viewBox="0 0 24 24"
    aria-labelledby="MenuRightIcon"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="MenuRightIcon">{alt}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.586 12L9.293 7.707l1.414-1.414L16.414 12l-5.707 5.707-1.414-1.414L13.586 12z"
    />
  </svg>
);

MenuRightIcon.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default MenuRightIcon;
